
import { API_BASE_URL as BASE_API_URL, WS_URL } from '../../constants/constants';


export const API_BASE_URL = `${BASE_API_URL}v1aux`;


export const TUTOR_API_BASE_URL = `${BASE_API_URL}v1aux`;

export const ROUTE = {
  INITIATE: 'sessionStreamInitiate',            
  PREPARE_TUTOR: 'sessionStreamPrepareTutor',   
  PREPARE_AUX: 'sessionStreamPrepareAux',      
};

export const WS_BASE_URL = WS_URL;

export const CLIENT_ID = 'talktrees-stream';

export const TUTOR_DEVICE_ID = 'tut01';
export const SEGMENT_LENGTH_FALLBACK = 30;
export const HEARTBEAT_MS = 10000;        

export const DEVICE_STATE = {
  INITIATED: 'initiated',
  RECORDING: 'recording',
  PAUSED: 'paused',
  STOPPED: 'stopped',
  STALE: 'stale',
  WAITING: 'waiting'
};
export const WS_MSG = {
  SESSION_START:  'SESSION_START',
  SESSION_STOP:   'SESSION_STOP',
  SESSION_ENDED:  'SESSION_ENDED',
  ALL_STOPPED:    'ALL_STOPPED',
  STATE_UPDATE:   'STATE_UPDATE',
  HEARTBEAT:      'HEARTBEAT',
  ROSTER:         'ROSTER',
  SESSION_STATE:  'SESSION_STATE',
};

export const ROLE = { TUTOR: 'tutor', AUX: 'aux' };